import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
    },
    dispatch,
  )

const ConnectedMainView = connect(null, mapDispatchToProps)(MainView)

export default ConnectedMainView
